<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu main-menu-two">
        <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->



    <!--Main Slider Start-->
    <section class="main-slider">
        <div class="swiper-container thm-swiper__slider">
            <div class="swiper-wrapper">


                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-1.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <h4 class="main-slider__sub-title">Welcome to </h4>
                                    <h2 class="main-slider__title">SHINGAD SHIPPING <br> <span> LINES PVT LTD </span>
                                        <br>
                                        <!-- <span>Simplified</span>     -->
                                    </h2>
                                    <p class="main-slider__text"> Your trusted Maritime Solutions Partner
                                    </p>

                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-2.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">100% Satisfaction</h4> -->
                                    <h2 class="main-slider__title"> Reliable export of
                                        <br> Kerala Spices, Agri. &amp; <br> <span>forest products
                                        </span>
                                    </h2>
                                    <p class="main-slider__text"> We proposes to export the
                                        Kerala hill , <br> forest and agricultural Products
                                        such as Pepper, Cardamom, Cinnamon, Clove, Nutmeg,<br>
                                        Bay Leaves, Ginger,Forest Honey, Bamboo Products etc…

                                    </p>

                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-3.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">International Logistics</h4> -->
                                    <h2 class="main-slider__title"> Reliable Shipping. <br>

                                        <span>Global reach.
                                        </span>

                                    </h2>
                                    <p class="main-slider__text"> Designed to Move Kerala’s Finest
                                        Products Worldwide with Confidence. Efficient Logistics &amp;

                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-4.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">International Logistics</h4> -->
                                    <h2 class="main-slider__title"> Hydrographic &amp; Marine
                                        <br><span> Engineering
                                            Consultancy </span>
                                    </h2>
                                    <p class="main-slider__text"> Specialists in Hydrography,
                                        Dredging Surveys, <br>Engineering Consultancy &amp;
                                        Port Operations </p>

                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-5.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">International Logistics</h4> -->
                                  <h2  class="main-slider__title"> Maritime &amp; Customs <br
                                        ><span >legal
                                        consultancy </span></h2>
                                         <p  class="main-slider__text">Maritime &amp; Customs
                                    consultancy and legal proceedings <br > at appropriate
                                    courts.Providing Trusted Legal Assistance in Maritime &amp; Customs <br
                                        >consultancy for International Shipping and Export
                                    Operations</p>
                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="swiper-pagination" id="main-slider-pagination"></div>
            <!-- If we need navigation buttons -->

        </div>
    </section>
    <!--Main Slider End-->



    <!--About Two Start-->
    <section class="about-two">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="about-two__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="about-two__img-box">
                            <div class="about-two__img">
                                <img src="assets/images/resources/about-two-img-1.jpg" alt="">
                            </div>
                            <div class="about-two__img-two">
                                <img src="assets/images/resources/about-two-img-2.jpg" alt="">
                            </div>
                            <div class="about-two__counter">
                                <div class="shape1"><img src="assets/images/shapes/about-two-shape-1.png" alt="">
                                </div>
                                <div class="count-text-box count-box">
                                    <h2 class="count-text" data-stop="5" data-speed="1500">35</h2>
                                    <span class="plus">+</span>
                                </div>

                                <p>Years Of <br>
                                    Experience</p>
                            </div>
                            <!-- <div class="about-two__shape-2 float-bob-x">
                                <img src="assets/images/shapes/about-two-shape-2.png" alt="">
                            </div> -->
                            <div class="about-two__shape-3">
                                <img src="assets/images/shapes/about-two-shape-3.png" alt="">
                            </div>
                            <!-- <div class="about-two__shape-4 float-bob-y">
                                <img src="assets/images/shapes/about-two-shape-4.png" alt="">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="about-two__right">
                        <div class="section-title text-left sec-title-animation animation-style2">
                            <div class="section-title__tagline-box">
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-1">
                                    <i class="fas fa-ship"></i>
                                </div>
                                <h6 class="section-title__tagline">ABOUT US</h6>
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-2">
                                    <i class="fas fa-ship"></i>
                                </div>
                            </div>
                            <h3 class="section-title__title title-animation"> <span> </span>
                                Shingad Shipping Lines
                                Private Limited
                            </h3>
                        </div>
                        <p class="about-two__text">
                            Shingad Shipping Lines Pvt Ltd is an MSME-registered Indian startup company based in Kerala,
                            specializing in shipping, logistics, maritime consultancy, and international trade.
                            <br> <br>
                            We are committed to exporting premium quality Kerala Spices, hill, forest, and agricultural
                            products to global markets with strict quality control, hygienic packaging, and
                            international standards.
                            <br> <br>
                            Shingad Shipping Lines Pvt Ltd provides reliable and efficient Ship Chandling Services to
                            vessels calling at Indian ports.
                            <br>
                            Our experienced team ensures timely delivery, quality products, competitive pricing, and
                            compliance with port, customs, and maritime regulations.
                        </p>


                        <div class="about-two__btn-and-author-box mb-5">
                            <div class="about-two__btn-box">
                                <a routerLink="/about" class="thm-btn">Read More
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--About Two End-->


    <!-- Blog Two Start -->
    <section class="blog-two">
        <div class="container">
            <div class="section-title text-center sec-title-animation animation-style1">
                <div class="section-title__tagline-box">
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-1">
                        <i class="fas fa-ship"></i>
                    </div>
                    <h6 class="section-title__tagline"> Our Services</h6>
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-2">
                        <i class="fas fa-ship"></i>
                    </div>
                </div>
                <h3 class="section-title__title title-animation">Shingad Shipping Services
                    <span> </span>
                </h3>
            </div>
            <div class="row">
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInLeft" data-wow-delay="100ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-4.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/spices"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/spices">Export / Imports </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                            <h3 class="blog-two__title"><a routerLink="/spices">Shipping Logistics & Export / Imports
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/spices" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInUp" data-wow-delay="300ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-3.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/crew-change-services"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/crew-change-services">Maritime </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                            <h3 class="blog-two__title"><a routerLink="/crew-change-services">Shipping & Maritime
                                    Operations
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/crew-change-services" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInRight" data-wow-delay="500ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-2.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/port-operations"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/port-operations">Port & Hydrography</a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                            <h3 class="blog-two__title"><a routerLink="/port-operations">Port and Hydrography
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/port-operations" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInLeft" data-wow-delay="100ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-1.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/legal-services"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/legal-services"> Legal Services </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                            <h3 class="blog-two__title"><a routerLink="/legal-services">Legal Consultancy Services
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/legal-services" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
            </div>
        </div>
    </section>
    <!-- Blog Two End -->






    <!--Why Choose Two Start-->
    <section class="why-choose-two">
        <div class="why-choose-two__pattern"
            style="background-image: url(assets/images/shapes/why-choose-two-pattern.png);"></div>
        <div class="why-choose-two__bg-box">
            <div class="why-choose-two__shape-bg"
                style="background-image: url(assets/images/shapes/why-choose-two-shpae-bg.png);"></div>
        </div>
        <div class="why-choose-two__img reveal">
            <img src="assets/images/resources/why-choose-two-img-1.png" alt="">
        </div>

        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="why-choose-two__left">
                        <div class="why-choose-two__title-box">
                            <div class="section-title text-left sec-title-animation animation-style1">
                                <div class="section-title__tagline-box">
                                    <span class="section-title__tagline-border"></span>
                                    <div class="section-title__shape-1">
                                        <i class="fas fa-ship"></i>
                                    </div>
                                    <h6 class="section-title__tagline">Why Choose us</h6>
                                    <span class="section-title__tagline-border"></span>
                                    <div class="section-title__shape-2">
                                        <i class="fas fa-ship"></i>
                                    </div>
                                </div>
                                <h3 class="section-title__title title-animation">Reliable Maritime Solutions

                                    <span>You Can Trust</span>
                                </h3>
                            </div>
                            <p class="why-choose-two__text" style=" text-align: justify;">At Shingad Shipping Lines, we
                                deliver dependable maritime services through operational excellence, industry expertise,
                                and a customer-first approach. From vessel handling to legal consultancy, we ensure
                                seamless, efficient, and reliable support at every stage.</p>
                        </div>


                        <div class="why-choose-two__point-box">

                            <ul class="why-choose-two__point">

                                <li>
                                    <div class="why-choose-two__icon">
                                        <span> <i class="fas fa-award"></i></span>
                                    </div>
                                    <div class="why-choose-two__content">
                                        <h4>Trusted Shipping Partner</h4>
                                        <p>Delivering dependable maritime solutions with integrity, reliability, and
                                            excellence.</p>
                                    </div>
                                </li>

                                <li>
                                    <div class="why-choose-two__icon">
                                        <span> <i class="fas fa-tags"></i></span>
                                    </div>
                                    <div class="why-choose-two__content">
                                        <h4>Fast & Efficient Operations</h4>
                                        <p> Ensuring timely vessel handling and seamless port operations with maximum
                                            efficiency.</p>
                                    </div>
                                </li>



                            </ul>

                            <ul class="why-choose-two__point why-choose-two__point--two">

                                <li>
                                    <div class="why-choose-two__icon">
                                        <span> <i class="fas fa-truck"></i></span>
                                    </div>
                                    <div class="why-choose-two__content">
                                        <h4>
                                            Global Maritime Expertise</h4>
                                        <p>Providing world-class shipping solutions backed by extensive industry
                                            experience.</p>
                                    </div>
                                </li>

                                <li>
                                    <div class="why-choose-two__icon">
                                        <span><i class="fas fa-headset"></i> </span>
                                    </div>
                                    <div class="why-choose-two__content">
                                        <h4>Expert Legal Consultancy</h4>
                                        <p> Offering professional maritime legal guidance for compliance and regulatory
                                            support.</p>
                                    </div>
                                </li>



                            </ul>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Why Choose Two End-->



    <!--Testimonials Two Start -->

    <section class="product-section">
        <div class="container">

            <!-- Section Heading -->
            <div class="product-heading">
                <div class="heading-tag">
                    <span></span>
                    OUR PRODUCTS
                </div>

                <h2>Exports and <strong>Imports</strong></h2>

                <!-- Navigation Arrows -->
                <div class="slider-controls">
                    <button type="button" class="slider-arrow prev-arrow" aria-label="Previous products"
                        (click)="scrollProducts(-1)">
                        <i class="fas fa-chevron-left"></i>
                    </button>

                    <button type="button" class="slider-arrow next-arrow" aria-label="Next products"
                        (click)="scrollProducts(1)">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <!-- Horizontal Product Slider -->
            <div class="product-slider" #productScroller (wheel)="onProductWheel($event)">

                <!-- Product 1 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-1.jpg" alt="Premium black pepper"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Pepper</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Premium black pepper with rich aroma, bold flavor, and export-grade quality.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 2 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-2.jpg" alt="Premium green cardamom"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Cardamom</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Premium green cardamom with natural aroma, rich flavor, and superior quality.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 3 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-3.jpg" alt="Natural cinnamon"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Cinnamon</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Natural cinnamon with distinctive aroma and flavour, ideal for culinary use.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 4 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-4.jpg" alt="Aromatic cloves"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Clove</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Aromatic clove with strong fragrance and unique taste for various applications.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 5 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-8.jpg" alt="Pure turmeric powder"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Turmeric</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Pure turmeric with high curcumin, ideal for cooking and traditional wellness.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 6 -->
                <article class="product-card">
                    <a routerLink="/spices-products" class="product-image">
                        <img src="assets/images/services/service-details-img-9.jpg" alt="Traditional Malabar kudampuli"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>KudamPuli</h3>
                        <span class="product-category">SPICES</span>
                        <div class="product-divider"></div>
                        <p>Traditional Malabar tamarind, perfect for authentic fish curries and recipes.</p>
                        <a routerLink="/spices-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 7 -->
                <article class="product-card">
                    <a routerLink="/agricultural-products" class="product-image">
                        <img src="assets/images/services/service-details-img-13.jpg" alt="Premium rice" loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Rice</h3>
                        <span class="product-category">AGRICULTURAL PRODUCTS</span>
                        <div class="product-divider"></div>
                        <p>Premium quality rice selected for taste, texture, and everyday cooking.</p>
                        <a routerLink="/agricultural-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

                <!-- Product 8 -->
                <article class="product-card">
                    <a routerLink="/forest-products" class="product-image">
                        <img src="assets/images/services/service-details-img-14.jpg" alt="Natural forest products"
                            loading="lazy">
                    </a>
                    <div class="product-content">
                        <h3>Forest Products</h3>
                        <span class="product-category">FOREST PRODUCTS</span>
                        <div class="product-divider"></div>
                        <p>Carefully selected natural forest products for quality-conscious buyers.</p>
                        <a routerLink="/forest-products" class="read-more">
                            Read More <i class="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </article>

            </div>
        </div>
    </section>
    ```
    <!--Testimonials Two End -->

    <!--Contact One Start -->
    <section class="contact-one">
        <div class="contact-one__shape-bg"
            style="background-image: url(assets/images/shapes/contact-one-shape-bg.png);"></div>
        <div class="contact-one__bg-img"
            style="background-image: url(assets/images/backgrounds/contact-one-bg-img.jpg);"></div>
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6">
                    <div class="contact-one__left">
                        <div class="contact-one__video-link">
                            <a href="https://youtube.com/shorts/K-RJS8Vcz8g?feature=share" class="video-popup">
                                <div class="contact-one__video-icon">
                                    <span class="fa fa-play"></span>
                                    <i class="ripple"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="contact-one__right wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="contact-one__content">
                            <p class="contact-one__tagline">Please feel free to</p>
                            <h2 class="contact-one__title">Contact Us </h2>
                            <form class="contact-one__form contact-form-validated"
                                action="https://dreamlayout.mnsithub.com/html/tanspot/main-html/assets/inc/sendemail.php"
                                method="POST">
                                <div class="contact-one__content-box">
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Your Name" name="name" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="email" placeholder="Email Address" name="email" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Phone Number" name="phone" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Message" name="Message">
                                    </div>
                                </div>

                                <div class="contact-one__content-bottom">
                                    <button type="submit" class="thm-btn">Submit</button>

                                </div>
                                <div class="result"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Contact One End -->

    <!-- Team Two Start -->
    <section class="team-two" style="display: none;">
        <div class="container">
            <div class="section-title text-center sec-title-animation animation-style1">
                <div class="section-title__tagline-box">
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-1">
                        <i class="fas fa-ship"></i>
                    </div>
                    <h6 class="section-title__tagline">Our Team Members</h6>
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-2">
                        <i class="fas fa-ship"></i>
                    </div>
                </div>
                <h3 class="section-title__title title-animation">Board of Directors

                </h3>
            </div>
            <div class="team-two__carousel owl-carousel owl-theme">
                <!-- Team Two Single Start -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-2.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. K.j.Thomas</a></h3>
                            <p class="team-two__sub-title"> M.com. Ll.b., cert. Arb& med</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-4.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. K.Venugopal</a></h3>
                            <p class="team-two__sub-title"> Msw., mba,Llm</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->



                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-3.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html">Adv. K.Pradeep Kumar</a></h3>
                            <p class="team-two__sub-title">Bsc. Ll.b, mbl </p>
                        </div>
                    </div>
                </div>


                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-1.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. V.Gerosh Kumar</a></h3>
                            <p class="team-two__sub-title">B.tech,mca, Fis, Llm</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->

                <!-- Team Two Single End -->
            </div>
        </div>
    </section>
    <!-- Team Two End -->



    <app-bees-footer></app-bees-footer>

</div><!-- /.page-wrapper -->